import { createContext } from "react";

export const StatisticsContext = createContext({
  organizations: [],
  setOrganizations: () => {},
  selectedOrganizations: [],
  setSelectedOrganizations: () => {},
  selectedLabels: [],
  setSelectedLabels: () => {},
  selectedArtists: [],
  setSelectedArtists: () => {},
  selectedRecordings: [],
  setSelectedRecordings: () => {},
  selectedReleases: [],
  setSelectedReleases: () => {},
  labels: [],
  setLabels: () => {},
  artists: [],
  setArtists: () => {},
  recordings: [],
  setRecordings: () => {},
  releases: [],
  setReleases: () => {},
  stage: 'END',
  setStage: () => {},
  start: null,
  setStart: () => {},
  end: null,
  setEnd: () => {}
})